import { api } from "@api/api";
import { ApiResponse } from "@shared/types";
import { MapIntegrationPlan } from "@modules/mapIntegrationPlans/types";

import { ListMapIntegrationPlansQueryFilters } from "./types";

export async function getMapIntegrationPlansService(filters?: ListMapIntegrationPlansQueryFilters): Promise<MapIntegrationPlan[]> {
  try {
    const { data } = await api.get<ApiResponse<MapIntegrationPlan>>(`v1/subscription_mapintegrationplan_admin/`, {
      params: {
        ...filters,
        page: filters?.page,
        page_size: filters?.perPage,
      },
    });
    return data.results;
  } catch (error) {
    console.error("Error fetching mapintegrationplans:", error);
    throw error;
  }
}

/**
 * Busca TODOS os mapeamentos de um convênio, percorrendo todas as páginas.
 */
export async function getAllMapIntegrationPlansService(
  agreementId: string | number
): Promise<MapIntegrationPlan[]> {
  const allResults: MapIntegrationPlan[] = [];
  let page = 1;
  const pageSize = 500;
  let hasMore = true;

  try {
    while (hasMore) {
      const { data } = await api.get<ApiResponse<MapIntegrationPlan>>(
        `v1/subscription_mapintegrationplan_admin/`,
        {
          params: {
            agreement: agreementId,
            page,
            page_size: pageSize,
          },
        }
      );

      allResults.push(...data.results);
      hasMore = data.next !== null;
      page++;
    }

    return allResults;
  } catch (error) {
    console.error("Error fetching all mapintegrationplans:", error);
    throw error;
  }
}
